// libs
import { useEffect } from 'react';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import { useSession } from 'next-auth/react';
// App
import { useCountShopOrders, useGetShopOrdersEvents } from 'app-shared/lib/api/shop-operations/shop';
import { countOrZero, getShopIdWhenAllowed } from './pending-counts.utils';
import { ORDERS_TO_VALIDATE_OR_PREPARE_STATUSES } from './pending-counts.constants';

const usePendingOrdersCount = (shopId: number | undefined, isAllowed: boolean): number => {
  const { data: session } = useSession();
  const today = new Date();
  const allowedShopId = getShopIdWhenAllowed(shopId, isAllowed);
  const { data: orderSavedEvent } = useGetShopOrdersEvents(allowedShopId, session);
  const { data: ordersToValidateOrPrepareCount, mutate: refreshOrdersToValidateOrPrepareCount } = useCountShopOrders(
    allowedShopId,
    startOfDay(today),
    endOfDay(today),
    ORDERS_TO_VALIDATE_OR_PREPARE_STATUSES
  );

  useEffect(() => {
    if (!orderSavedEvent) return;

    refreshOrdersToValidateOrPrepareCount();
  }, [orderSavedEvent]);

  const pendingOrdersCount = countOrZero(ordersToValidateOrPrepareCount);

  return pendingOrdersCount;
};

export default usePendingOrdersCount;
